import { useQuery } from "@tanstack/react-query";
import { axios } from "../../../shared/lib/axios";
import { getClient } from "../../../shared/config/urlConfig";

const parseSignUpParams = (data) => {
  var enableSignUp = false;
  var signUpVerificationField = "email";
  var signUpRegistrationFields = [];
  switch (data.AUTOCADASTRO_ATIVO) {
    case "S":
      enableSignUp = true;
      break;
    case "N":
      enableSignUp = false;
      break;
    default:
      enableSignUp = false;
      break;
  }

  switch (data.AUTOCADASTRO_CHAVE) {
    case "CPF":
      signUpVerificationField = "documentNumber";
      break;
    case "email":
      signUpVerificationField = "email";
      break;
    default:
      signUpVerificationField = "email";
      break;
  }
  if (!data.AUTOCADASTRO_SENHA_PADRAO) {
    signUpRegistrationFields.push("password");
  }

  data.AUTOCADASTRO_CAMPOS_ADICIONAIS?.split(",").map((key) => {
    switch (key) {
      case "DTNASC":
        signUpRegistrationFields.push("birthDayDate");
        break;
      case "EMPRESA":
        signUpRegistrationFields.push("companyName");
        break;
      case "CARGO":
        signUpRegistrationFields.push("jobPosition");
        break;
      case "ENDERECO":
        signUpRegistrationFields.push(
          "postalCode",
          "addressDescription",
          "number",
          "addressComplement",
          "neighborhood",
          "city",
          "state",
          "country"
        );
        break;
      default:
        break;
    }
    return null;
  });

  return {
    ...data,
    enableSignUp,
    signUpVerificationField,
    signUpRegistrationFields,
  };
};

export const getSignUpParams = async () => {
  const res = await axios.middleware("/aluno.asmx/parametros_autoinscricao", {
    params: {
      b: getClient(),
    },
  });

  return parseSignUpParams(res?.[0]?.data[0]);
};

export const useSignUpParams = ({ config } = {}) => {
  return useQuery({
    ...config,
    queryFn: getSignUpParams,
    queryKey: ["signUpParams"],
  });
};
